import React, { Component } from "react";
import {
  Row,
  Col,
  Spin,
  Button,
  DatePicker,
  Radio,
  Table,
  Modal,
  Popover,
  Checkbox,
  Divider,
} from "antd";
import moment from "moment";
import { app } from "../../app";
import TeamSeleted from "../../components/TeamSeleted";
import Card from "../../components/Card";
import ReportAdd from "./ReportAdd";
import TaskAdd from "./TaskAdd1";
import SignReport1 from "./SignReport1";
import SignReport2 from "./SignReport2";

import date_locale from "antd/lib/date-picker/locale/zh_CN";
import api from "../../api";
import utils from "../../utils";
import ReportDration from "./ReportDration";
import config from "../../config";
import WhiteList from "./WhiteList";
import "../../css/sign-report-add.css";
import { node } from "prop-types";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const { RangePicker } = DatePicker;
const CheckboxGroup = Checkbox.Group;

class SignReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      select_team: {},
      rights: app.getData("rights"),
      select_tab: "2",
      sel_tab: null,
      page: 1,
      total: 0,
      edit_modal: false,
      white_modal: false,
      duration_modal: false,
      edit_id: null,
      dataList: [],
      teamList: [],
      exportDate: [],
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      export_visible: false,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.setData({ sel_tab: "1" });
    if (app.getData("token")) {
      this.setData({ rights: app.getData("rights") });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 获取报表列表
   * @returns {Promise<void>}
   */
  handleReportsData = async (page = 1) => {
    await this.setData({ page, data_loading: true });
    let { start_time, end_time, select_team } = this.state,
      params = {
        start_time,
        end_time,
        page,
        teamno: select_team.teamno,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg, total } = await app.post(api.ReportsLists, params);
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    if (page === this.state.page) {
      await this.setData({
        dataList: utils.addArrayKey(data),
        data_loading: false,
        total: Number(total || 0),
      });
    }
  };

  /**
   * 选项选择变更
   * @param e
   */
  handleTabChange2 = (e) => {
    let { value } = e.target;
    let { sel_tab } = this.state;
    if (value === sel_tab) return;
    this.setData({ sel_tab: value });
  };

  /**
   * 获取报表记录列表
   * @returns {Promise<void>}
   */
  handleReportsRecordData = async (page = 1) => {
    await this.setData({ page, data_loading: true });
    let { select_team } = this.state,
      params = {
        page,
        teamno: select_team.teamno,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg, total } = await app.post(
        api.ReportsOperateList,
        params
      );
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    if (page === this.state.page) {
      await this.setData({
        dataList: utils.addArrayKey(data),
        data_loading: false,
        total: Number(total || 0),
      });
    }
  };

  /**
   * 选择队伍
   */
  handleSelectTeam = async (team, index, teamList) => {
    await this.setData({ select_team: team, teamList });
    let { select_tab } = this.state;
    if (select_tab === "1") {
      await this.handleReportsRecordData();
    } else if (select_tab === "2") {
      await this.handleReportsData();
    }
  };

  /**
   * 日期筛选变更
   * @param date
   */
  handleDateChange = async (date) => {
    if (date.length > 1) {
      await this.setData({
        start_time: date[0].format("YYYY-MM-DD"),
        end_time: date[1].format("YYYY-MM-DD"),
      });
    } else {
      await this.setData({ start_time: null, end_time: null });
    }
    await this.handleReportsData();
  };

  /**
   * Tab筛选变更
   * @param e
   */
  handleTabChange = async (e) => {
    let { value } = e.target;
    await this.setData({ select_tab: value, total: 0, dataList: [] });
    switch (value) {
      case "1":
        await this.handleReportsRecordData();
        break;
      case "2":
        await this.handleReportsData();
        break;
    }
  };

  /**
   * 发布任务
   * @param e
   */
  handleOpenEditModal2 = (select_team, edit_id) => {
    this.setData({ edit_modal2: true, select_team, edit_id, isDo: false });
  };
  // 关闭任务
  handleCloseEditModal2 = async (flush) => {
    let { select_team } = this.state;
    if (flush === true) {
      await this.setData({
        select_tab: "2",
        total: 0,
        dataList: [],
        edit_modal2: false,
      });
      await this.handleReportsData(select_team.team_id);
    } else {
      await this.setData({ edit_modal2: false });
    }
  };

  /**
   * 打开编辑框
   * @param e
   */
  handleOpenEditModal = (edit_id) => {
    this.setData({ edit_modal: true, edit_id });
  };

  /**
   * 关闭编辑框
   */
  handleCloseEditModal = async (flush) => {
    if (flush === true) {
      await this.setData({
        select_tab: "2",
        total: 0,
        dataList: [],
        edit_modal: false,
      });
      await this.handleReportsData();
    } else {
      await this.setData({ edit_modal: false });
    }
  };

  /**
   * 今天没有任务按钮
   */
  handleReportsTask = async () => {
    let { select_team } = this.state,
      params = {
        teamno: select_team.teamno,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, msg } = await app.post(api.ReportsTask, params);
    if (flag === 1) {
      app.alert(msg, "success");
    } else {
      app.alert(msg, "warn");
    }
  };

  /**
   * 跳转签到
   */
  handleSign = () => {
    this.props.history.push("/sign");
  };

  /**
   * 打开时长管理
   */
  handleOpenDurationModal = (id) => {
    this.setData({ duration_id: id, duration_modal: true });
  };

  /**
   * 关闭时长管理
   */
  handleCloseDurationModal = () => {
    this.setData({ duration_id: null, duration_modal: false });
  };

  /**
   * 打开白名单
   */
  handleOpenWhiteModal = (id) => {
    this.setData({ white_modal: true });
  };

  /**
   * 关闭时白名单
   */
  handleCloseWhiteModal = () => {
    this.setData({ white_modal: false });
  };

  /**
   * 导出队伍选择
   * @param checkedList
   */
  handleExportCheckChange = (checkedList) => {
    const { teamList } = this.state;
    this.setData({
      checkedList,
      indeterminate:
        !!checkedList.length && checkedList.length < teamList.length,
      checkAll: checkedList.length === teamList.length,
    });
  };

  /**
   * 导出队伍全选
   * @param e
   */
  handleExportCheckAll = (e) => {
    const { teamList } = this.state;
    this.setData({
      checkedList: e.target.checked ? teamList.map((team) => team.teamno) : [],
      indeterminate: false,
      checkAll: e.target.checked,
    });
  };

  /**
   * 导出
   * @returns {Promise<void>}
   */
  handleExport = async () => {
    let { checkedList, exportDate } = this.state;
    let params = [
      `token=${app.getToken()}`,
      `indexno=${app.getData("indexno")}`,
      `account=${app.getData("account")}`,
    ];
    if (exportDate.length === 2) {
      params.push(
        `start_time=${exportDate[0].format("YYYY-MM-DD")}`,
        `end_time=${exportDate[1].format("YYYY-MM-DD")}`
      );
    }
    if (checkedList.length > 0) {
      params.push(`teamno=${checkedList.join(",")}`);
    } else {
      app.alert("请选择导出队伍", "warn", "10%");
      return;
    }
    let url = config.serverUrl + api.ReportsExport + "?" + params.join("&");
    app.downFile(url);
    app.alert("导出成功", "success", "10%");
    await this.setData({
      exportDate: [],
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      export_visible: false,
    });
  };

  render() {
    let {
        white_modal,
        select_team,
        select_tab,
        data_loading,
        checkedList,
        export_visible,
        exportDate,
        dataList,
        page,
        isDo,
        total,
        edit_id,
        edit_modal,
        edit_modal2,
        duration_modal,
        duration_id,
        indeterminate,
        teamList,
        checkAll,
        sel_tab,
      } = this.state,
      loadNode = (
        <Row
          className="data-loading"
          type="flex"
          align="middle"
          justify="center"
        >
          <Spin />
        </Row>
      ),
      content = loadNode,
      columns = [
        {
          title: "创建日期",
          dataIndex: "work_create_time",
          key: "work_create_time",
          width: "15%",
        },
        {
          title: "队伍",
          dataIndex: "teamname",
          key: "teamname",
          width: "12%",
        },
        {
          title: "服务项目名称",
          dataIndex: "title",
          key: "title",
          width: "14%",
        },
        {
          title: "更改项目",
          dataIndex: "work_status",
          key: "work_status",
          width: "10%",
          render(status, { update_type }) {
            let text = "";
            if (status === "1") text = "添加";
            else if (status === "2") text = "编辑";
            return text + update_type;
          },
        },
        {
          title: "修改前",
          dataIndex: "work_before",
          key: "work_before",
          width: "12%",
        },
        {
          title: "修改后",
          dataIndex: "work_after",
          key: "work_after",
          width: "12%",
        },
        {
          title: "操作人",
          dataIndex: "vname",
          key: "vname",
          width: "10%",
        },
        {
          title: "编辑日期",
          dataIndex: "work_time",
          key: "work_time",
          width: "15%",
        },
      ],
      columns2 = [
        {
          title: "创建日期",
          dataIndex: "create_time",
          key: "create_time",
          width: "15%",
        },
        {
          title: "队伍",
          dataIndex: "teamname",
          key: "teamname",
          width: "15%",
        },
        {
          title: "服务项目名称",
          dataIndex: "title",
          key: "title",
          width: "25%",
        },
        {
          title: "任务进程",
          dataIndex: "whether_succeed",
          key: "whether_succeed",
          width: "10%",
          render: (ws) => {
            if (ws === "11") {
              return "已完成";
            } else {
              return "未完成";
            }
          },
        },
        {
          title: "操作人",
          dataIndex: "vname",
          key: "vname",
          width: "10%",
          render: (vname) => vname || " - ",
        },
        {
          title: "操作",
          dataIndex: "id",
          key: "id",
          width: "25%",
          render: (id) => {
            return (
              <span>
                <Button
                  onClick={() => this.handleOpenDurationModal(id)}
                  type="primary"
                  size="small"
                  style={{ marginRight: 20 }}
                >
                  服务时长管理
                </Button>
                <Button
                  onClick={() => this.handleOpenEditModal(id)}
                  type="primary"
                  size="small"
                >
                  查看/修改
                </Button>
              </span>
            );
          },
        },
      ],
      exportNode = (
        <div>
          <div style={{ width: 800, height: 600, overflowY: "auto" }}>
            <div style={{ margin: "10px 0" }}>选择日期:</div>
            <div>
              <RangePicker
                value={exportDate}
                disabledDate={(current) =>
                  current && current > moment().endOf("day")
                }
                onChange={(datas) => this.setData({ exportDate: datas })}
              />
            </div>
            <div style={{ margin: "10px 0" }}>选择队伍:</div>
            <div>
              <Checkbox
                indeterminate={indeterminate}
                onChange={this.handleExportCheckAll}
                checked={checkAll}
              >
                全选
              </Checkbox>
              <Divider style={{ margin: "8px 0" }} />
              <CheckboxGroup
                value={checkedList}
                onChange={this.handleExportCheckChange}
              >
                <Row>
                  {teamList.map((team, i) => {
                    return (
                      <Col span={8} key={i}>
                        <Checkbox value={team.teamno}>{team.teamname}</Checkbox>
                      </Col>
                    );
                  })}
                </Row>
              </CheckboxGroup>
            </div>
          </div>
          {"1".indexOf(app.getData("rights")) > -1 ? (
            <div
              style={{
                textAlign: "right",
                marginTop: 10,
                paddingTop: 12,
                borderTop: "1px solid #ddd",
              }}
            >
              <Button
                onClick={() => this.setData({ export_visible: false })}
                style={{ marginRight: 20 }}
              >
                取消
              </Button>
              <Button type="primary" onClick={this.handleExport}>
                确认导出
              </Button>
            </div>
          ) : null}
        </div>
      );
    let tab_disabled = !sel_tab;
    switch (sel_tab) {
      case "1":
        content = <SignReport1 />;
        break;
      case "2":
        content = <SignReport2 />;
        break;
    }
    return (
      <div className="sign-report">
        <Row
          className="sr-content"
          style={{
            borderTop: "none",
          }}
        >
          {/* <Col span={6} className="team-select">
            <TeamSeleted
              handleData={this.handleSelectTeam}
              dataApi={api.ReportsTeamAll}
            />
          </Col> */}
          <Col span={23} offset={1} className="src-infos">
            <Card
              style={{ borderTop: "none" }}
              title={
                <Row type="flex" justify="space-between" align="middle">
                  <Col> <div className="sr-title">任务管理</div></Col>
                  <Col style={{padding:'0'}}>
                    <RadioGroup
                      defaultValue="1"
                      buttonStyle="solid"
                      onChange={this.handleTabChange2}
                    >
                      <RadioButton value="1">单队任务</RadioButton>
                      <RadioButton value="2">多队任务</RadioButton>
                    </RadioGroup>
                    {"123".indexOf(app.getData("rights")) !== -1 ? (
                      <Button
                        type="primary"
                        style={{ marginRight: 20, marginLeft: 20 }}
                        onClick={this.handleOpenWhiteModal}
                      >
                        任务管理白名单
                      </Button>
                    ) : null}
                    {"1".indexOf(app.getData("rights")) > -1 ? (
                      <Popover
                        content={exportNode}
                        visible={export_visible}
                        title="导出报表"
                        trigger="click"
                        onVisibleChange={(visible) =>
                          this.setData({ export_visible: visible })
                        }
                        placement="bottomRight"
                      >
                        <Button
                          type="primary"
                          style={{ marginRight: 20 }}
                          onClick={() => this.setData({ export_visible: true })}
                        >
                          导出报表
                        </Button>
                      </Popover>
                    ) : null}
                    {/* <Button
                      type="primary"
                      onClick={() => this.handleOpenEditModal()}
                    >
                      新增报表
                    </Button> */}
                    {/* <Button
                      type="primary"
                      style={{ margin: "0 20px" }}
                      onClick={this.handleReportsTask}
                    >
                      今天没有任务
                    </Button>
                    <Button type="primary" onClick={this.handleSign}>
                      签到
                    </Button> */}
                  </Col>
                </Row>
              }
            >
              {/* <Col>
                  {select_tab === "2" ? (
                    <span>
                      <span>日期筛选： </span>
                      <DatePicker.RangePicker
                        onChange={this.handleDateChange}
                        locale={date_locale}
                        format="YYYY年MM月DD日"
                        disabledDate={(current) =>
                          current && current > moment().endOf("day")
                        }
                      />
                    </span>
                  ) : null}
                </Col> */}
              {/* <Col>
                  <RadioGroup
                    defaultValue="2"
                    buttonStyle="solid"
                    onChange={this.handleTabChange}
                  >
                    <RadioButton value="2">工作报表</RadioButton>
                    <RadioButton value="1">修改记录</RadioButton>
                  </RadioGroup>
                </Col> */}

              {/* <Table
                columns={select_tab === "2" ? columns2 : columns}
                locale={app.tbLocale(data_loading)}
                loading={data_loading}
                dataSource={dataList}
                size="small"
                className="srci-table"
                scroll={{ y: "calc(100vh - 450px)" }}
                pagination={{
                  current: page,
                  pageSize: 20,
                  total,
                  showTotal: (t) => `总数量：${t}`,
                  onChange: async (p) => {
                    if (select_tab === "1") {
                      await this.handleReportsRecordData(p);
                    } else if (select_tab === "2") {
                      await this.handleReportsData(p);
                    }
                  },
                }}
              /> */}
            </Card>

            {content}
          </Col>
        </Row>
        <Modal
          visible={edit_modal}
          title={edit_id ? "编辑/查看" : "新增报表"}
          onCancel={this.handleCloseEditModal}
          footer={null}
          width={1000}
          maskClosable={false}
          destroyOnClose={true}
          bodyStyle={{
            height: "calc(100vh - 100px)",
            overflowY: "auto",
            minHeight: 400,
            position: "relative",
          }}
          style={{ top: 20, paddingBottom: 20 }}
        >
          <ReportAdd
            edit_id={edit_id}
            teamno={select_team.teamno}
            onClose={this.handleCloseEditModal}
            onDuration={this.handleOpenDurationModal}
          />
        </Modal>
        <Modal
          visible={duration_modal}
          title="服务时长管理"
          footer={null}
          width={800}
          zIndex={1001}
          maskClosable={false}
          destroyOnClose={true}
          onCancel={this.handleCloseDurationModal}
          bodyStyle={{ height: "calc(100vh - 100px)" }}
          style={{ paddingBottom: 0, top: 20 }}
        >
          <ReportDration
            id={duration_id}
            onClose={this.handleCloseDurationModal}
          />
        </Modal>
        <Modal
          visible={white_modal}
          title="报表管理白名单"
          footer={null}
          width="80%"
          maskClosable={false}
          destroyOnClose={true}
          onCancel={this.handleCloseWhiteModal}
          bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
          style={{ paddingBottom: 0, top: 20 }}
        >
          <WhiteList />
        </Modal>
        <Modal
          visible={edit_modal2}
          title={
            edit_id ? (edit_id && isDo ? "查看任务" : "编辑任务") : "发布任务"
          }
          onCancel={this.handleCloseEditModal2}
          footer={null}
          maskClosable={false}
          destroyOnClose={true}
          width={1000}
          bodyStyle={{
            height: "calc(100vh - 100px)",
            overflowY: "auto",
            minHeight: 400,
            position: "relative",
          }}
          style={{ top: 20, paddingBottom: 20 }}
        >
          <TaskAdd
            edit_id={edit_id}
            select_team={select_team}
            isDo={isDo}
            type={"1"}
            onClose={this.handleCloseEditModal2}
            onDuration={this.handleOpenDurationModal2}
          />
        </Modal>
      </div>
    );
  }
}

export default SignReport;



// WEBPACK FOOTER //
// ./src/routes/sign/SignReport.jsx